module.exports = __webpack_public_path__ + "media/images/money-c3989af6.png";